import { render, staticRenderFns } from "./PartsControlManualQuote.vue?vue&type=template&id=2fc7b22a&scoped=true"
import script from "./PartsControlManualQuote.vue?vue&type=script&lang=js"
export * from "./PartsControlManualQuote.vue?vue&type=script&lang=js"
import style0 from "./PartsControlManualQuote.vue?vue&type=style&index=0&id=2fc7b22a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7b22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc7b22a')) {
      api.createRecord('2fc7b22a', component.options)
    } else {
      api.reload('2fc7b22a', component.options)
    }
    module.hot.accept("./PartsControlManualQuote.vue?vue&type=template&id=2fc7b22a&scoped=true", function () {
      api.rerender('2fc7b22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/partsControl/unorderedparts/PartsControlManualQuote.vue"
export default component.exports